module.exports = __webpack_public_path__ + "slider-2.jpg?f8256c8ddac8f302f57f607e8a0b8688";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/slider-2.jpg
// module id = 303
// module chunks = 0